import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-special-category-setup',
  templateUrl: './special-category-setup.component.html',
  styleUrls: ['./special-category-setup.component.scss']
})
export class SpecialCategorySetupComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mLocation = new FormControl('');
  public mSite = new FormControl('');
  public mCategory = new FormControl('');
  public mVehicles = new FormControl('');

  _mSitesData: any[] = [];
  _mCategoryData: any[] = [];
  _mVehiclesData: any[] = [];
  unPushedValues: any[] = [];
  rows = [];
  showFlag: boolean = false;
  cities: any[] = [];
  _mData: any[] = [];
  getVehicleData: any = [];

  constructor(
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private readonly localStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService) {
  }

  ngOnInit() {
    this._mFormGroup = this.fb.group({
      'location': this.mLocation,
      'site': this.mSite,
      'category': this.mCategory,
      'vehicles': this.mVehicles
    });
    this.loadCities();
    this.getCategory();
  }

  loadCities() {
    let companyid: number = +this.localStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser +
      companyid,
      success => {
        this.cities = success.body;
        if (this.cities && this.cities.length > 0) {
          this.mLocation.setValue(this.cities[0].locationId);
          this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
        }
      },
      error => {
      }
    );
  }

  getSitesByCityId(event) {
    const cityId = event.target.value;
    if (!cityId) return;
    this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + cityId, (success) => {
      if (success.status == 200) {
        this._mSitesData = success.body;
        if (this._mSitesData && this._mSitesData.length > 0) {
          this.mSite.setValue(this._mSitesData[0].siteId);
        }
      } else {
        this._mSitesData = [];
        this.notifyService.showInfo("No sites found for the selected city", null);
      }
    },
      (error) => {
      });
  }

  getCategory() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllCategory, (success) => {
      if (success.status == 200) {
        this._mCategoryData = success.body;
        if (this._mCategoryData && this._mCategoryData.length > 0) {
          this.mCategory.setValue(this._mCategoryData[0].id);
        }
      } else {
        this._mCategoryData = [];
        this.notifyService.showInfo("No categories found", null);
      }
    }, (error) => {
    });
  }

  showMapping() {
    this.showFlag = false;
    this.unPushedValues = [];
    this.rows = [];
    if (!this.mCategory.value) {
      this.notifyService.showWarning('Please select pickup point type!', null);
      return;
    }
    this.getVehicleTypesBasedonSiteId();
  }

  getVehicleTypesBasedonSiteId() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getVehicleTypesBySiteId + "?siteId=" + this.mSite.value,
      success => {
        if (success.status == 200) {
          this.getVehicleData = success.body;
          this.getAllVehicleTypes();
        } else if (success.status == 204) {
          this.notifyService.showInfo("No Vehicles Found", null);
        }
      },
      error => {
        this.notifyService.showError(error.message, null);
      }
    );
  }

  getAllVehicleTypes() {
    this.unPushedValues = [];
    this.rows = this.getVehicleData.map(vehicleType => ({
      id: vehicleType.id,
      value: vehicleType.vehicleType,
      seatCapacity: Array.from({ length: vehicleType.seatCapacity - 1 }, (_, i) => ({ value: i + 1 })),
      allocatedSeats: 1
    }));
    this.getMapping();
  }

  getMapping() {
    if (!this.mSite.value) return;
    this.unPushedValues = [];
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getspecialcategorybysiteidandspecialcategoryid}${this.mSite.value}&specialcategoryid=${this.mCategory.value}`,
      (success) => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          this.showFlag = true;
          success.body.forEach(vehicleType => {
            this.rows = this.rows.filter(r => r.id !== vehicleType.id);
            this.unPushedValues.push({
              id: vehicleType.id,
              value: vehicleType.vehicleType,
              seatCapacity: Array.from({ length: vehicleType.seatCapacity - 1 }, (_, i) => ({ value: i + 1 })),
              allocatedSeats: vehicleType.allocatedSeats,
              state: 'checked'
            });
          });
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError('Error in Fetching Mapping!', null);
      }
    );
  }

  saveMapping() {
    if (!this.mCategory.value) {
      this.notifyService.showWarning('Please select pickup point type!', null);
      return;
    }
    if (!this.mSite.value) return;
    const vehicleTypes = this.unPushedValues.map(item => ({ id: item.id, seatCapacity: item.allocatedSeats }));
    const url = `${ApiConstants.addSpecialCategory}?categoryid=${this.mCategory.value}&siteid=${this.mSite.value}`;
    this.apiService.doPostRequestWithResponse(url, vehicleTypes, (success) => {
      if (success.status === 201) {
        this.notifyService.showSuccess(success.body.message, null);
        this.resetForm();
      } else {
        this.notifyService.showInfo('No changes made', null);
      }
    }, (error) => {
      this.notifyService.showError('Failed to Update!', null);
    });
  }

  resetForm() {
    this._mFormGroup.reset();
    this.mLocation.setValue('');
    this.mSite.setValue('');
    this.mCategory.setValue('');
    this.unPushedValues = [];
    this.rows = [];
    this.showFlag = false;
    this.getVehicleData = [];
  }

  isAllChecked() {
    return this.rows.every(_ => _.state);
  }

  checkAll(checks) {
    if (checks.checked) {
      this.rows.forEach(x => {
        x.state = checks.checked;
        this.onValueChecked({ checked: true }, x);
      });
    }
  }

  onValueChecked(checked, sel) {
    if (checked.checked) {
      this.rows = this.rows.filter(r => r.id !== sel.id);
      this.unPushedValues.push(sel);
    }
  }


  unCheckAll(checks) {
    if (!checks.checked) {
      this.unPushedValues.forEach(x => {
        x.state = checks.checked;
        this.onSelValuesChecked({ checked: false }, x);
      });
    }
  }

  onSelValuesChecked(checked, unselect) {
    if (!checked.checked) {
      this.rows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
    }
  }

  onSelValueChecked(checked, unselect) {
    if (!checked.checked) {
      this.rows.push(unselect);
      this.unPushedValues = this.unPushedValues.filter(r => r.id !== unselect.id);
    }
  }

  onSelectedSeatCapacity(value, row) {
    this.unPushedValues.forEach((element, i) => {
      if (element.id == row.id) {
        this.unPushedValues[i].allocatedSeats = value;
      }
    });
  }
}
